import api from "../util/api";

const API_BASE = "/public";

const request = async (url, options = {}) => {
    /* const response = await fetch(
        `${API_BASE}${url}`,
        {
            ...options,
            credentials: "include",
            headers: {
                Accept: "application/json",
                ...(options.headers || {}),
            },
        }
    ); */


    const response = await api.get(API_BASE + url);



    const result = await response.data;

    if (result.success === false) {
        throw new Error(
            result.message ||
            "Unable to load data."
        );
    }

    return result;
};


/*
|--------------------------------------------------------------------------
| Profile
|--------------------------------------------------------------------------
*/

export const getPublicProfile = async () => {
    return request("/profile");
};


/*
|--------------------------------------------------------------------------
| News
|--------------------------------------------------------------------------
*/


export const getPublicProjects = async (
    page = 1,
    perPage = 6
) => {
    const params = new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    return request(
        `/projects?${params.toString()}`
    );
};



export const getPublicNews = async (
    page = 1,
    perPage = 9,
    filters = {}
) => {

    const params =
        new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    if (filters.search) {
        params.set(
            "search",
            filters.search
        );
    }

    if (filters.category) {
        params.set(
            "category",
            filters.category
        );
    }

    return request(
        `/news?${params.toString()}`
    );
};



export const getPublicProject = async (slug) => {
    return request(
        `/projects/${encodeURIComponent(slug)}`
    );
};


/* export const getNewsArticle = async (slug) => {
  return request(`/news/${slug}`);
};
 */

export const getFeaturedNews =
    async () => {
        return request(
            "/news/featured"
        );
    };


export const getNewsCategories =
    async () => {
        return request(
            "/news/categories"
        );
    };


export const getNewsArticle =
    async (slug) => {
        return request(
            `/news/${slug}`
        );
    };


/*
|--------------------------------------------------------------------------
| Media
|--------------------------------------------------------------------------
*/

export const getPublicMedia =
    async (
        page = 1,
        perPage = 12,
        folder = ""
    ) => {

        const params =
            new URLSearchParams();

        params.set("page", page);
        params.set(
            "per_page",
            perPage
        );

        if (folder) {
            params.set(
                "folder",
                folder
            );
        }

        return request(
            `/media?${params.toString()}`
        );
    };


export const getPublicLegislative = async (
    page = 1,
    perPage = 9
) => {
    const params = new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    return request(`/legislative?${params.toString()}`);
};